"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oAuthLogin = void 0;
const exenv_1 = require("exenv");
const track_1 = require("./track");
const tracking_1 = require("@food/tracking");
const maxRetry = 10;
const oAuthLogin = async ({ socialType, }) => {
    (0, tracking_1.track)({
        ...track_1.authTrackOverride,
        action: { type: 'auth_getting_social_token', socialType },
    });
    return new Promise((resolve, reject) => {
        // se siamo sul server non possiamo loggarci, semplicemente esco.
        if (!exenv_1.canUseDOM) {
            reject(new Error('Server side cannot try login!'));
            return;
        }
        let retryCount = 0;
        const authWin = window.open(socialType.loginURL(), 'OAUTH2');
        const timerId = setInterval(async function () {
            try {
                if (authWin && typeof authWin.opener === 'object') {
                    // if user closed authWin stop awaiting auth
                    try {
                        if (authWin.location.pathname !== 'blank') {
                            const codeUri = authWin.location.search; // this throwing a error while user not on the same domain(see "same origin policy"), we catch exception and processing like awaiting user back
                            clearInterval(timerId); // when user get back after remote auth on our domain we again have access to authWin properties
                            const matches = /\?code=([^&#]+)/.exec(codeUri);
                            if (matches) {
                                const code = matches[1];
                                authWin.close();
                                clearInterval(timerId);
                                resolve(decodeURIComponent(code));
                            }
                            else {
                                retryCount += 1;
                                if (retryCount === maxRetry) {
                                    //authWin.close();
                                    clearInterval(timerId);
                                }
                            }
                        }
                    }
                    catch (err) {
                        console.warn(err);
                        // waiting for user back
                        // IMPORTANT non va catchato perche' chrome restituisce un errore CORS per localhost, url social e auth.gruppofood.com
                    }
                }
                else {
                    clearInterval(timerId);
                }
            }
            catch (e) {
                clearInterval(timerId);
                reject(e);
            }
        }, 100);
    });
};
exports.oAuthLogin = oAuthLogin;
//# sourceMappingURL=oauth.js.map